<template>
  <div>
    <input type="checkbox" id="my-modal" class="modal-toggle" :checked="!user">
    <div class="modal">
      <div class="modal-box">
        <!-- <h3 class="font-bold text-lg">НЭВТРЭХ</h3> -->
        <div class="flex-0 btn btn-ghost px-2 flex items-center">
          <div class="font-title normal-case text-primary inline-flex text-lg transition-all duration-200 md:text-3xl">
            <span>Нэвтрэх <span class="text-base-content">цонх</span></span>
          </div>
        </div>
        <my-input v-model="username" name="username" label="Нэр" placeholder="Нэвтрэх нэр оруулна уу.." />
        <my-input v-model="password" name="password" label="Нууц үг" placeholder="Нууц үг оруулна уу.." type="password" />
        <div class="modal-action">
          <my-button type="link" size="default"><span class="normal-case">Нууц үгээ мартсан уу?</span></my-button>
          <my-button :loading="loading" type="primary" size="default" icon="login" @click="handleLogin">Нэвтрэх</my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['set_user']),
    async handleLogin () {
      try {
        this.loading = true
        if (!this.username) {
          this.customError('Хэрэглэгчийн нэр оруулна уу.')
        }
        if (!this.password) {
          this.customError('Нууц үг оруулна уу.')
        }
        const data = (await this.axios.post('auth/login', {
          username: this.username,
          password: this.password
        })).data
        this.username = ''
        this.password = ''
        this.set_user(data.user)
        localStorage.setItem('token', data.access_token)
        this.showToast('Амжилттай нэвтэрлээ.')
        setTimeout(() => window.location.reload(), 500)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
